module.exports = __webpack_public_path__ + "static/img/EC.ea705943.svg";